import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 强制重定向到标准端口（80或443） - 仅在生产环境生产构建后可能需要
// 开发环境下禁用此逻辑，否则会导致开发端口（3000/3001等）无法访问
if (process.env.NODE_ENV === 'production' && window.location.port && !['', '80', '443'].includes(window.location.port)) {
  const correctUrl = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}${window.location.search}`;
  console.warn(`检测到非标准端口 ${window.location.port}，正在重定向到 ${correctUrl}`);
  window.location.href = correctUrl;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Force unregister all service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
      console.log('Cleared service worker');
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
